import React from 'react';
import { StyledButton } from './styles';
import { ButtonProps } from './types';
import { ButtonKind, ButtonMode, ButtonSize } from './enums';

const modeToKind: Record<ButtonMode, ButtonKind> = {
  [ButtonMode.Primary]: ButtonKind.Primary,
  [ButtonMode.Secondary]: ButtonKind.Outline,
  [ButtonMode.Tertiary]: ButtonKind.Danger,
  [ButtonMode.Info]: ButtonKind.Soft,
};

const Button: React.FC<ButtonProps> = ({
  mode = ButtonMode.Primary,
  kind: kindProp,
  size = ButtonSize.Big,
  isFullWidth,
  icon: Icon,
  children,
  ...props
}) => {
  const kind = kindProp ?? modeToKind[mode];
  const buttonTextVariant = size === ButtonSize.Big ? 'body' : 'caption';

  return (
    <StyledButton
      variant={buttonTextVariant}
      {...{ kind, size, isFullWidth, ...props }}
    >
      {Icon && <Icon />}
      {children}
    </StyledButton>
  );
};

export default Button;
